import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { TokenStorageService } from './_services/token-storage.service';
import { Router, RouterModule } from '@angular/router';
import { SubscribeService } from './_services/subscribe.service';
import { SwPush, SwUpdate } from '@angular/service-worker';
import { fromEvent, interval, Observable, Subscription } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AuthService } from './_services/auth-service.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterModule, MatIconModule, MatButtonModule],
  providers: [SubscribeService, SwUpdate],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./app.component.scss']
})


export class AppComponent implements OnInit {
  showUsername: string;
  updateSubscription;
  onlineEvent: Observable<Event>;
  offlineEvent: Observable<Event>;
  subscriptions: Subscription[] = [];
  connectionStatusMessage: string;
  connectionStatus: string;
  @Output() aClickedEvent = new EventEmitter<string>();
  // public static isLoggedIn: boolean = false;
  public static baseUrl = (() => {
    if (!environment.baseUrl) {
      throw new Error('Configuratiefout: baseUrl is niet ingesteld in environment.prod.ts.');
    }
    return environment.baseUrl;
  })();
  readonly VAPID_PUBLIC_KEY = "BLuUCwKhcTd3F71h1EfO1UCEsaGl35HEQ1WvwMSydZygZMzJcqq05eyklFyJ_-6-MNRyEODinte7qS6iWanFyek";
  constructor(private tokenservice: TokenStorageService
    , private subscribeService: SubscribeService
    , private swPush: SwPush
    , private update: SwUpdate
    , private authService: AuthService
    , private router: Router) {

    this.checkForUpdates();
    window.addEventListener("focus", () => this.play());
    //this.subscribe();
  };

  ngOnInit(): void {

    this.checkInternetConnection();

    //  this.authService.isLoggedIn$.subscribe(user => {
    //    console.log("we zijn gewijzigd naar " + user.isLoggedIn + " het was: "+AppComponent.isLoggedIn);
    //    if (user.isLoggedIn || this.tokenservice.getToken() ){ //&& !AppComponent.isLoggedIn) {
    //      AppComponent.isLoggedIn = user.isLoggedIn;
    //      console.log('Naar de lijst');
    //      this.router.navigate(['/list']);
    //    } else  {

    //      if (!AppComponent.isLoggedIn) {
    //        console.log('Naar de login pagina');
    //        this.router.navigate(['/login']);
    //      }
    //       AppComponent.isLoggedIn = user.isLoggedIn;

    //    }
    //     else if (user.isLoggedIn == AppComponent.isLoggedIn) {
    //      console.log('Het is gelijk gebleven');
    //    }

    //  });
    this.authService.isLoggedIn$.subscribe(user => {
      if (!user.isLoggedIn && user.loginAction) {
        console.log('Naar de login pagina');
        this.router.navigate(['/login']);
      }else if(user.loginAction){
        this.router.navigate(['/list']);
      }
    });
  }
  play() {
    if (this.tokenservice && !this.tokenservice.getToken() && this.router) { this.router.navigate(['/login']); }
  }

  checkInternetConnection() {
    /**
   * Get the online/offline status from browser window
   */
    this.onlineEvent = fromEvent(window, 'online');
    this.offlineEvent = fromEvent(window, 'offline');

    this.subscriptions.push(this.onlineEvent.subscribe(e => {
      this.connectionStatusMessage = 'Back to online';
      this.connectionStatus = 'online';
      this.aClickedEvent.emit(this.connectionStatus);
      console.log('Online...');
    }));

    this.subscriptions.push(this.offlineEvent.subscribe(e => {
      this.connectionStatusMessage = 'Connection lost! You are not connected to internet';
      this.connectionStatus = 'offline';
      this.aClickedEvent.emit(this.connectionStatus);
      console.log('Offline...');
    }));
  }
  public checkForUpdates(): void {
    this.updateSubscription = this.update.versionUpdates.subscribe(evt => {
      switch (evt.type) {
        case 'VERSION_DETECTED':
          console.log(`Downloading new app version: ${evt.version.hash}`);
          break;
        case 'VERSION_READY':
          console.log(`Current app version: ${evt.currentVersion.hash}`);
          console.log(`New app version ready for use: ${evt.latestVersion.hash}`);
          this.promptUser();
          break;
        case 'VERSION_INSTALLATION_FAILED':
          console.log(`Failed to install app version '${evt.version.hash}': ${evt.error}`);
          break;
      }
    });
    // console.log('function checkforupdates new!');

    if (this.update.isEnabled) {
      //   console.log('update is enabled11');
      // Required to enable updates on Windows and ios.
      interval(30000).subscribe(() => {
        this.update.checkForUpdate().then(() => {
          console.log('Checking for updates.');
        });
      });

    } else {
      console.log('update cheching not possible');
    }

    // Important: on Safari (ios) Heroku doesn't auto redirect links to their https which allows the installation of the pwa like usual
    // but it deactivates the swUpdate. So make sure to open your pwa on safari like so: https://example.com then (install/add to home)
  }

  promptUser(): void {
    this.update.activateUpdate().then(() => {
      console.log('update found. Reload');
      window.location.reload();
    });
  }

  subscribe() {
    this.swPush.requestSubscription({
      serverPublicKey: this.VAPID_PUBLIC_KEY
    })
      .then(sub => this.subscribeService.addSubscription(sub).subscribe())
      .catch(err => console.error("Could not subscribe to notifications", err));
  }

  ngOnDestroy(): void {
    /**
    * Unsubscribe all subscriptions to avoid memory leak
    */
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }



  AppisLoggedIn(): boolean {
    //AppComponent.isLoggedIn = false;
    if (this.tokenservice.getToken()) {
      // AppComponent.isLoggedIn = true;
      this.showUsername = this.tokenservice.getUser().username;
      return true;
    }
    return false;
  }

  Signout(): void {
    this.tokenservice.signOut();
    this.router.navigate(['/login']);
  }
  title = 'shoppinglist';
}
